<template>
  <div class="alert_container" v-if="isShown">
    <div class="alert_bg"></div>
    <!-- 开团弹窗 -->
    <div :class="['alert_outbox', targetClassName? targetClassName : 'alert_build_team']">
      <div class="alert_content border_box">
        <div class="corner"></div>
        <div class="corner"></div>
        <div class="corner"></div>
        <div class="corner"></div>

        <div @click="closeDialog" class="close_btn" v-if="!hideClose"></div>
        <div class="title"></div>
        <!-- <p class="text">是否消耗<span>60点券/￥6元</span>购买廉颇-艰难并发起团购?</p>
        <p class="text">2人即可拼团成功，成团后道具将发放到 <span>微信191区-谋士之战 溶溶月月</span> 游戏内邮箱中哦~ 拼团不成功将全额退款。</p>-->
        <div v-html="dialogContent"></div>
        <div class="btn_box two_btn" v-if="confirmText && cancelText">
          <!-- <div class="btn left_btn" @click="cancel">点击订阅<span>即视获取返利通知</span></div> -->
          <div @click="cancel" class="btn left_btn">{{cancelText || "取消"}}</div>
          <div @click="confirm" class="btn right_btn">{{confirmText || "确认"}}</div>
        </div>
        <div class="btn_box" v-else-if="confirmText">
          <div @click="confirm" class="btn one_btn">{{confirmText || "确认"}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Dialog",
  props: ["isShown", "dialogContent", "confirmText", "cancelText", "onConfirm", "onCancel", "close", "targetClassName", "hideClose"],
  methods: {
    closeDialog() {
      !this.hideClose && this.close()
    },
    confirm() {
      this.closeDialog()
      this.onConfirm && this.onConfirm()
    },
    cancel() {
      this.closeDialog()
      this.onCancel && this.onCancel()
    }
  }
}
</script>
